export enum InputType {
	Text = 'text',
	Password = 'password',
	Number = 'number',
}
